import request from '@/utils/request'
import qs from 'qs'
export function getSyntheticFreeList(query) {
  return request({
    url: '/report-service/v1/report/free-room-general',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getSyntheticFreeListExcel(query) {
  return request({
    url: '/report-service/v1/report/free-room-general/to-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
